<label class="st-field-label">{{ label }}</label>
<div class="input-group">
  <span class="input-group-text xy"><i class="bi bi-envelope"></i></span>
  <input [id]="idVal" type="email" class="form-control st-input-email" placeholder=""
    aria-label="Email" aria-describedby="Type Email"
    [value]="inputVal"
    [required]="requiredVal"
    [disabled]="disabled" [maxLength]="50"
  />
</div>
